export default "__VITE_ASSET__b851152a__"